import { Boton, Seccion, Spinner } from 'asocomponents'
import React, { useEffect, useState } from 'react'
import CartasSiniestrosServices from '../../../../modules/CartasSiniestros/application/CartasSiniestrosServices'
import { WindowOpener } from '../../../helpers/window-opener'
import { WEBURLEGALES } from '../../../helpers/frontend'

export default function CartasSiniestros({ cargaHabilitada, idDenuncia }) {

    const [cartas, setCartas] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [message, setMessage] = useState("")

    const obtenerCartasSiniestro = async () => {
        setIsLoading(true)

        const cartasSiniestrosService = new CartasSiniestrosServices()
        const result = await cartasSiniestrosService.obtenerDetalleCartaEnviada(idDenuncia)
        setCartas(result)
        setIsLoading(false)
    }

    const sonResponse = (err, res) => {
        if (err) {
            setMessage(res)
        } else {
            setMessage(res)
        }
    }

    useEffect(() => {
        if (idDenuncia && idDenuncia !== -1)
            obtenerCartasSiniestro()
    }, [idDenuncia])

    return (
        <div>
            {cargaHabilitada &&
                <>
                    <Seccion titulo="CARTAS DEL SINIESTRO" />

                    {isLoading ? <Spinner color="red" size="30" /> :
                        cartas &&
                        <div className="overflow-x-auto">
                            <div className="shadow-md sm:rounded-lg m-3 w-[95%] mx-auto">
                                <table className="table-fixed text-xs text-left rtl:text-right text-gray-500 w-full">
                                    <thead className="text-[0.6rem] text-gray-700 uppercase bg-gray-200">
                                        <tr>
                                            <th scope="col" className="text-center  py-1" style={{ width: "10%" }}>F. generación</th>
                                            <th scope="col" className="text-center  py-1" style={{ width: "10%" }}>F. Envío</th>
                                            <th scope="col" className="text-center  py-1" style={{ width: "10%" }}>F. Novedad</th>
                                            <th scope="col" className="text-center  py-1" style={{ width: "10%" }}>Cod. Seg.</th>
                                            <th scope="col" className="text-center  py-1" style={{ width: "15%" }}>Estado</th>
                                            <th scope="col" className="text-center  py-1" style={{ width: "25%" }}>Modelo carta</th>
                                            <th scope="col" className="text-center" style={{ width: "3%" }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {cartas.map((carta, index) => (
                                            <tr className="bg-white border-b hover:bg-gray-50 text-[0.6rem]" key={carta.idCartaEnviada ?? index}>
                                                <td className="text-center py-1">{carta.fechaGeneracion}</td>
                                                <td className="text-center py-1">{carta.fechaEnvio}</td>
                                                <td className="text-center py-1">{carta.fechaNovedad}</td>
                                                <td className="text-center py-1">{carta.codSeguimiento}</td>
                                                <td className="text-center py-1">{carta.estado}</td>
                                                <td className="text-center py-1">{carta.modelo}</td>
                                                <WindowOpener url={`${WEBURLEGALES}/VisorCartaSiniestro/${carta.idCartaEnviada}`} bridge={sonResponse} name="VisorArchivo" >
                                                    <Boton icono="eye" height="h-6" width="w-8" alt="Ver Carta" />
                                                </WindowOpener>                                                
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </> 
            }
        </div>
    )
}
